const STORAGE_KEY = 'wifi_recent_searches';
const MAX_RECENT = 6;

function getRecentSearches() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function saveRecentSearch(term) {
  const trimmed = (term || '').trim();
  if (!trimmed) return;

  let recent = getRecentSearches().filter((existing) => existing.toLowerCase() !== trimmed.toLowerCase());
  recent.unshift(trimmed);
  recent = recent.slice(0, MAX_RECENT);

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(recent));
  } catch {
    /* localStorage unavailable (private mode, quota) — recent searches simply won't persist */
  }
}

function clearRecentSearches() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
  renderRecentSearches();
}

function renderRecentSearches() {
  const container = document.querySelector('[data-wifi-recent-searches]');
  const pillsWrapper = document.querySelector('[data-wifi-recent-searches-pills]');
  if (!container || !pillsWrapper) return;

  const recent = getRecentSearches();

  if (recent.length === 0) {
    container.hidden = true;
    pillsWrapper.replaceChildren();
    return;
  }

  container.hidden = false;
  pillsWrapper.replaceChildren(
    ...recent.map((term) => {
      const link = document.createElement('a');
      link.className = 'wifi-search-suggestions__pill';
      link.href = `/search?q=${encodeURIComponent(term)}`;
      link.setAttribute('data-wifi-search-term', '');
      link.textContent = term;
      return link;
    })
  );
}

function handleSubmit(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('predictive-search-form')) return;

  const input = form.querySelector('input[name="q"]');
  if (input && input.value) {
    saveRecentSearch(input.value);
  }
}

function handleTermClick(event) {
  const pill = event.target instanceof Element ? event.target.closest('[data-wifi-search-term]') : null;
  if (!pill || !(pill instanceof HTMLAnchorElement)) return;

  const url = new URL(pill.href, window.location.origin);
  const term = url.searchParams.get('q');
  if (term) saveRecentSearch(term);
}

function handleClearClick(event) {
  const clearButton = event.target instanceof Element ? event.target.closest('[data-wifi-clear-recent]') : null;
  if (!clearButton) return;

  event.preventDefault();
  clearRecentSearches();
}

function handleFocusIn(event) {
  if (event.target instanceof HTMLElement && event.target.id === 'cmdk-input') {
    renderRecentSearches();
  }
}

function init() {
  renderRecentSearches();
  document.addEventListener('submit', handleSubmit);
  document.addEventListener('click', handleTermClick);
  document.addEventListener('click', handleClearClick);
  document.addEventListener('focusin', handleFocusIn);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
